module.exports = __webpack_public_path__ + "img/Brandon.e1045701.png";